'use client'

import { FormFieldDialog } from './form-field-dialog'

interface AddFormCustomFieldDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  schemaId: string
  onSuccess: (updatedTree?: any) => void
}

// Wrapper component for backward compatibility
export function AddFormCustomFieldDialog(props: AddFormCustomFieldDialogProps) {
  return <FormFieldDialog {...props} mode="add" />
}
